export function getFilenameFromDisposition(dispositionHeader, fallbackFilename = 'Export.pdf') {
  if (!dispositionHeader) {
    return fallbackFilename;
  }

  const utf8Match = String(dispositionHeader).match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch {
      return utf8Match[1];
    }
  }

  const fallbackMatch = String(dispositionHeader).match(/filename="?([^";]+)"?/i);
  return fallbackMatch?.[1] || fallbackFilename;
}

export function triggerBlobDownload(blob, filename) {
  const objectUrlApi = window.URL || window.webkitURL;
  const safeBlob = blob instanceof Blob ? blob : new Blob([blob], { type: 'application/pdf' });

  if (!objectUrlApi || typeof objectUrlApi.createObjectURL !== 'function') {
    throw new Error('Download wird von diesem Browser nicht unterstuetzt.');
  }

  const url = objectUrlApi.createObjectURL(safeBlob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);

  try {
    anchor.click();
  } finally {
    window.setTimeout(() => {
      anchor.remove();
      objectUrlApi.revokeObjectURL(url);
    }, 1000);
  }
}

export async function extractPdfErrorMessage(error, fallback) {
  const fallbackMessage = error?.response?.data?.error || error?.message || fallback || 'PDF konnte nicht erstellt werden.';
  const responseData = error?.response?.data;
  if (!responseData || typeof responseData.text !== 'function') {
    return fallbackMessage;
  }

  try {
    const text = await responseData.text();
    if (!text) {
      return fallbackMessage;
    }

    try {
      const parsed = JSON.parse(text);
      return parsed?.error || fallbackMessage;
    } catch {
      return text.slice(0, 300);
    }
  } catch {
    return fallbackMessage;
  }
}

export function downloadPdfResponse(response, fallbackFilename = 'Export.pdf') {
  const contentDisposition = response?.headers?.['content-disposition'] || response?.headers?.get?.('content-disposition') || '';
  const filename = getFilenameFromDisposition(contentDisposition, fallbackFilename);
  triggerBlobDownload(response?.data, filename);
  return filename;
}